'use client';

import {
  defaultSortByAtom,
  enableHomeNewsletterAtom,
  heroAtom,
  homeCssAtom,
  homeCssVariablesAtom,
  homeJsAtom,
  homeNewsletterDescriptionAtom,
  homeNewsletterTitleAtom,
  metaDescriptionAtom,
  metaTitleAtom,
  showSortMenuAtom,
  showTagTabsAtom,
} from 'app/blog/[domain]/_components/design-state';
import type { schema } from 'database';
import { useStore } from 'jotai';
import { useHydrateAtoms } from 'jotai/utils';

export type HydrateHomeAtoms = {
  hero: string;
  cssVariables?: schema.HomeCssVariables | null;
  showSortMenu?: boolean;
  showTagTabs?: boolean;
  defaultSortBy?: schema.SortByOption;
  metaTitle?: string;
  metaDescription?: string;
  enableHomeNewsletter?: boolean;
  homeNewsletterTitle?: string | null;
  homeNewsletterDescription?: string | null;
  customCss?: string | null;
  customJs?: string | null;
};

export function HydrateHomeAtoms(props: HydrateHomeAtoms) {
  const store = useStore();
  useHydrateAtoms(
    // @ts-expect-error - fix types
    [
      [heroAtom, props.hero],

      typeof props.showSortMenu === 'boolean' && [
        showSortMenuAtom,
        props.showSortMenu,
      ],
      typeof props.showTagTabs === 'boolean' && [
        showTagTabsAtom,
        props.showTagTabs,
      ],
      typeof props.defaultSortBy === 'string' && [
        defaultSortByAtom,
        props.defaultSortBy,
      ],

      props.metaTitle && [metaTitleAtom, props.metaTitle],
      props.metaDescription && [metaDescriptionAtom, props.metaDescription],

      typeof props.enableHomeNewsletter === 'boolean' && [
        enableHomeNewsletterAtom,
        props.enableHomeNewsletter,
      ],
      props.homeNewsletterTitle && [
        homeNewsletterTitleAtom,
        props.homeNewsletterTitle,
      ],
      props.homeNewsletterDescription && [
        homeNewsletterDescriptionAtom,
        props.homeNewsletterDescription,
      ],

      props.customCss && [homeCssAtom, props.customCss],
      props.customJs && [homeJsAtom, props.customJs],
      props.cssVariables && [homeCssVariablesAtom, props.cssVariables],
    ].filter(Boolean),
    {
      store,
    },
  );

  return <></>;
}
